import { DefaultTheme } from "styled-components";

export const darkTheme:DefaultTheme = {
    green: {
        darker: "#2a9885",
        lighter: "#70c1b3",
    },
    red: "#e17676",
    black: {
        veryDark: "#141414",
        darker: "#181818",
        lighter: "#2f2f2f",
    },
    white: {
        veryDark: "#a5a6b5",
        lighter: "#fff",
        darker: "#e5e5e5",
    },
    title: "#ef9b9b",
    screenPadding: {
        pc: 60,
        tablet: 35,
        mobile: 15,
    },
    backgroundColor: "#000",
};

export const lightTheme:DefaultTheme = {
    green: {
        darker: "#2a9885",
        lighter: "rgb(42 133 117)",
    },
    red: "#e17676",
    black: {
        veryDark: "rgb(199 200 210)",
        darker: "#fff",
        lighter: "rgb(229 232 239)",
    },
    white: {
        veryDark: "#141414",
        lighter: "#181818",
        darker: "#2f2f2f",
    },
    title: "#ef9b9b",
    screenPadding: {
        pc: 60,
        tablet: 35,
        mobile: 15,
    },
    backgroundColor: "#fff",
};

